import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountRoleService } from './account-role.service';


@Injectable({ providedIn: 'root' })
export class UserRouteRoleAccessService {
  constructor(public accountRoleService: AccountRoleService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return this.accountRoleService.getRoleState().pipe(
      map(() => {
        return this.isRouteAllowed(state);
      })
    );
  }

  private isRouteAllowed(state: RouterStateSnapshot): boolean {
    let canActivate = false;
    switch (true) {
      case state.url.includes('/case-mobility/'):
        canActivate = canActivate = !!this.accountRoleService.roles.canViewMobilityCases;
        break;

      case state.url.includes('/case/'):
        canActivate = this.accountRoleService.isCasesActive();

        switch (canActivate) {
          case state.url.includes('/case-summary'):
            canActivate = !!this.accountRoleService.roles.canViewTravelCasesCaseSummaryInformation;
            break;

          case state.url.includes('/attachments'):
            canActivate =
              !!this.accountRoleService.roles.canViewTravelCasesAttachmentInformation ||
              !!this.accountRoleService.roles.canViewTravelCasesAttachmentInformationExtended;
            break;

          case state.url.includes('/medical'):
            canActivate =
              !!this.accountRoleService.roles.canViewTravelCasesMedicalInformation ||
              !!this.accountRoleService.roles.canViewTravelCasesMedicalInformationExtended;
            break;

          case state.url.includes('/economy'):
            canActivate = !!this.accountRoleService.roles.canViewTravelCasesFinancialInformation;
            break;

          case state.url.includes('/customer-notes'):
            canActivate = !!this.accountRoleService.roles.canViewTravelCasesCustomerNotesInformation;
            break;
        }
        break;

      case state.url.startsWith('/cases'):
        canActivate =
          !!this.accountRoleService.roles.canViewTravelCases ||
          !!this.accountRoleService.roles.canViewMobilityCases;

        switch (true) {
          case state.url.includes('/travel'):
            canActivate = !!this.accountRoleService.roles.canViewTravelCases;
            break;

          case state.url.includes('/mobility'):
            canActivate = !!this.accountRoleService.roles.canViewMobilityCases;
            break;

        }
        break;

      case state.url.includes('/insights'):
        canActivate = this.accountRoleService.isInsightsActive();
        break;

      case state.url.includes('/economy/'):
        canActivate = this.accountRoleService.isEconomyActive();
        break;

      case state.url.includes('/products-contracts/'):
        canActivate = this.accountRoleService.isProductsAndContractsActive();
        break;

      case state.url.includes('/case-events/'):
        canActivate = this.accountRoleService.isCaseEventManagementActive();
        break;

      case state.url.includes('/major-incidents/'):
        canActivate = this.accountRoleService.isMajorIncidentsActive();
        break;

      case state.url.includes('/settings/'):
        switch (true) {
          case state.url.includes('/roles'):
            canActivate = !!this.accountRoleService.roles.canManageRoles;
            break;

          case state.url.includes('/user-management'):
            canActivate = !!this.accountRoleService.roles.canManageUsers;
            break;
        }
        break;
    }

    return canActivate;
  }
}
